<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('company_info') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="saveHandler">
                <i class="fa fa-floppy-o" aria-hidden="true"></i>
                {{$t('save')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item">COMPANY SETUP</div>
                </div>
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ចូលឈ្មោះក្រុមហ៊ុន</div>
                        <div class="error" v-if="!$v.model.LatinName.required">- សូមធ្វើការបញ្ចូលឈ្មោះក្រុមហ៊ុនជាឡាតាំង</div>
                        <div class="error" v-if="!$v.model.BusActivity.required">- សូមធ្វើការបញ្ចូលសកម្មភាពអាជីរកម្ម</div>
                        <div class="error" v-if="!$v.model.VatTin.required || !$v.model.TinHead.required">- សូមធ្វើកាបញ្ចូលតម្លៃ VAT TIN</div>
                        <div class="error" v-if="!$v.model.Email.required">- សូមធ្វើកាបញ្ចូលអាស័យអាដ្ឋានសារអេឡិចត្រូនិច</div>
                        <div class="error" v-if="!$v.model.Phone.required">- សូមធ្វើកាបញ្ចូលលេខទូរស័ព្ទ</div>
                        <div class="error" v-if="!$v.model.Commune.required">- សូមធ្វើកាបញ្ចូល ឃំុ~សង្កាត់</div>
                        <div class="error" v-if="!$v.model.District.required">- សូមធ្វើកាបញ្ចូល ក្រុង~ស្រុក~ខណ្ខ</div>
                        <div class="error" v-if="!$v.model.Capital.required">- សូមធ្វើកាបញ្ចូល រាជធានី~ខេត្ត</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group" :class="{ 'form-group-error': $v.model.VatTin.$error || $v.model.TinHead.$error }">
                                            <label class="label-control blue">VAT TIN</label>
                                            <div>
                                                <div class="row">
                                                    <div class="col-sm-3 col-lg-2">
                                                        <input type="text" class="form-control" v-model="$v.model.TinHead.$model"/>
                                                    </div>
                                                    <div class="col-sm-9 col-lg-10">
                                                        <b-form-input v-model="$v.model.VatTin.$model"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <b-form-group class="label-control blue" :label="$t('company_name')" :class="{ 'form-group-error': $v.model.Name.$error }">
                                    <b-form-input v-model="$v.model.Name.$model"/>
                                </b-form-group>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <b-form-group class="label-control blue" :label="$t('latin_name')" :class="{ 'form-group-error': $v.model.LatinName.$error }">
                                            <b-form-input v-model="$v.model.LatinName.$model"/>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <b-form-group class="label-control blue" :label="$t('company_activity')">
                                            <b-form-input v-model="$v.model.BusActivity.$model"/>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-6">
                                        <div :class="{ 'form-group-error': $v.model.Email.$error }">
                                            <b-form-group class="label-control blue" :label="$t('email')">
                                                <b-form-input v-model="$v.model.Email.$model"/>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6" :class="{ 'form-group-error': $v.model.Phone.$error }">
                                        <b-form-group class="label-control blue" :label="$t('phone')">
                                            <b-form-input v-model="$v.model.Phone.$model"/>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-6">
                                        <b-form-group class="blue" :label="$t('website')">
                                            <b-form-input v-model="model.Website"/>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="row" style="margin-top: 29px !important;">
                                    <div class="col-sm-12">
                                        <input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
                                        <img :src="img" alt="" class="img-thumbnail" style="width: 115px; height: 115px;" @click="$refs.file.click()">
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="label-control blue">{{ $t('home_no')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="model.Home"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="blue">{{ $t('street_no')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="model.Street"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="blue">{{ $t('group')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="model.Group"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="label-control blue">{{ $t('village')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="model.Village"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group" :class="{ 'form-group-error': $v.model.Commune.$error }">
                                            <label class="label-control blue">{{ $t('commune')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="$v.model.Commune.$model"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group" :class="{ 'form-group-error': $v.model.District.$error }">
                                            <label class="label-control blue">{{ $t('district')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="$v.model.District.$model"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group" :class="{ 'form-group-error': $v.model.Capital.$error }">
                                            <label class="label-control blue">{{ $t('capital')}}</label>
                                            <div>
                                                <input type="text" class="form-control" v-model="$v.model.Capital.$model"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    import Swal from "sweetalert2";
    export default {
        props: {},
        data: function() {
            return {
                model: {
                    Name: '',
                    LatinName: '',
                    BusActivity: '',
                    VatTin: '',
                    TinHead: '',
                    Email: '',
                    Phone: '',
                    Commune: '',
                    District: '',
                    Capital: ''
                },
                img: '/img/company-logo.png',
                formHead: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            };
        },
        validations:{
            model: {
                Name: { required },
                LatinName: { required },
                BusActivity: { required },
                VatTin: { required },
                TinHead: { required },
                Email: { required },
                Phone: { required },
                Commune: { required },
                District: { required },
                Capital: { required }
            }
        },
        created: function() {
            let loading = this.$loading.show();
            this.$api().post('company').then(res => {
                if (this.$isValid(res)) {
                    if(res.data.Data != null){
                        this.model = res.data.Data;
                        if(this.model.Logo != null){
                            this.img = this.$base() + 'image/logo/' + this.model.Logo;
                        }
                    }
                }
            }).finally(function(){ loading.hide(); });
        },
        methods: {
            saveHandler: function(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    let formData = new FormData();
                    formData.append('File', this.$refs.file.files[0]);
                    for (let p in this.model) {
                        let val = this.model[p];
                        if(val != null)
                            formData.append(p, val);
                    }
                    this.$api().post('company/save', formData, this.formHead).then(res => {
                        if (this.$isValid(res)) {
                            Swal.fire('Success', 'The company save success.', 'success');
                        }
                    }).finally(function () {
                        loading.hide();
                    });
                }
            },
            fileChangeHandler: function(e){
                const file = e.target.files[0];
                this.img = URL.createObjectURL(file);
            }
        }
    };
</script>
